import { render, staticRenderFns } from "./PerformanceComparisonSingle.vue?vue&type=template&id=0cd014a9&scoped=true"
import script from "./PerformanceComparisonSingle.vue?vue&type=script&lang=ts"
export * from "./PerformanceComparisonSingle.vue?vue&type=script&lang=ts"
import style0 from "./PerformanceComparisonSingle.vue?vue&type=style&index=0&id=0cd014a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd014a9",
  null
  
)

/* custom blocks */
import block0 from "./PerformanceComparisonSingle.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IxSurveyEsgSectionTitle: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/survey/EsgSectionTitle.vue').default,EsgPerformanceComparisonProgressBarSingle: require('/home/runner/work/assessment-service/assessment-service/frontend/components/esg/PerformanceComparisonProgressBarSingle.vue').default,EsgPortfolioDifferenceColumn: require('/home/runner/work/assessment-service/assessment-service/frontend/components/esg/PortfolioDifferenceColumn.vue').default})
